{% block swag_language_pack_settings_administration %}
    <swag-language-pack-settings-base
        :isLoading="isLoading"
        :packLanguages="packLanguages"
        settingsType="administration">
    </swag-language-pack-settings-base>
{% endblock %}